import {
  Route,
  Routes,
  Navigate,
  BrowserRouter as Router,
} from "react-router-dom";
import { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import Table from "../../pages/Table/Table.js";
import SpotEditor from "../../pages/SpotEditor/SpotEditor";
import HotSpotEditor from "../../pages/HotSpotEditor/HotSpotEditor";
import ToolsContainer from "../../pages/ToolsContainer/ToolsContainer.js";
import Header from "../../components/Header/Header.js";
import Login from "../../pages/Login/Login";
import { ModalProvider } from "../../common/ModalProvider";
import { LoaderPortal } from "../../components/LoaderPortal/LoaderPortal";
import AddNews from "../../pages/AddNews/AddNews.js";
import MySpots from "../../pages/MySpots/MySpots.js";
import { GoToTop } from "../../containers/GoToTop/GoToTop.js";
import CategoriesTextsForm from "../../pages/CategoriesTextsForm/CategoriesTextsForm";
import { setIsLoading, setUser } from "../../reduxSetup/action.js";
import { tokenAuthServices } from "../../services/api.js";
import TextCompiler from "../../pages/TextCompiler/TextCompiler.js";
import PremiumPlan from "../../pages/PremiumPlan/PremiumPlan.js";
import AddBlog from "../../pages/AddBlog/AddBlog.js";
import CheckPublications from "../../pages/CheckPublications/CheckPublications.js";
import "./App.scss";

const App = ({ user, setUser }) => {
  const { role } = user;
  useEffect(() => {
    setIsLoading(true);
    const currentToken = localStorage.getItem("token_user");
    if (currentToken)
      tokenAuthServices(currentToken)
        .then((response) => {
          if (!response || !response.data) {
            localStorage.removeItem("token_user");
            window.location.replace("/");
            return;
          }
          response?.data?.user &&
            setUser({ user: response.data.user, token: response.data.token });
        })
        .finally(() => {
          setIsLoading(false);
        });
  }, []);

  if (!localStorage.getItem("token_user")) {
    return (
      <div className="App">
        <Router>
          <LoaderPortal />
          <Routes>
            <Route path="/*" element={<Navigate replace to="/login" />} />
            <Route path="/login" element={<Login />} />
          </Routes>
        </Router>
      </div>
    );
  }
  return (
    <div className="App">
      <Router>
        <LoaderPortal />
        <ModalProvider>
          <GoToTop />
          <Header user={user} />
          <main className="pageContainer">
            {role === "user" && (
              <p className="welcome">
                Welcome! Soon Admin will update your access
              </p>
            )}
            {role === "content_manager" && (
              <Routes>
                <Route path="/add-news" element={<AddNews />} />
              </Routes>
            )}
            {(role === "researcher" || role === "admin") && (
              <Routes>
                <Route
                  path="/login"
                  element={<Navigate replace to="/spot-editor" />}
                />
                <Route path="/spot-editor" element={<SpotEditor />} />
                <Route path="/hot-spot-editor" element={<HotSpotEditor />} />
                <Route path="/my-spots" element={<MySpots />} />
                <Route path="/check" element={<Table />} />
                <Route path="/check-publications" element={<CheckPublications />} />
                <Route path="/tools" element={<ToolsContainer />} />
                <Route path="/add-news" element={<AddNews />} />
                <Route path="/add-blog" element={<AddBlog />} />
                <Route path="/categories" element={<CategoriesTextsForm />} />
                <Route path="/text-compiler" element={<TextCompiler />} />
                <Route path="/premium-plan" element={<PremiumPlan />} />
              </Routes>
            )}
          </main>
        </ModalProvider>
      </Router>
    </div>
  );
};

App.propTypes = {
  user: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  setUser: PropTypes.func,
};

const mapStateToProps = ({ user }) => {
  return {
    user,
  };
};
const mapDispatchToProps = {
  setUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
